import { render, staticRenderFns } from "./picker-link.vue?vue&type=template&id=0bb5372c"
import script from "./picker-link.vue?vue&type=script&lang=js"
export * from "./picker-link.vue?vue&type=script&lang=js"
import style0 from "./picker-link.vue?vue&type=style&index=0&id=0bb5372c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports